'use strict';

class Theme {
	constructor($) {
		this.$ = $;
	}
}

let $theme = new Theme(jQuery);

require('./polyfills/foreach.js');

//Include theme scripts
require('./menu.js');
require('./sliders.js');
require('./modals.js');
require('./sticky-header.js');
require('./smooth-scroll.js');
require('./faqs.js');
require('./archives.js');
require('./svgscroll.js');
require('./search.js');

//Component scripts
require('./components/alerts.js');
require('./components/browser-update-notification.js');
require('./components/divi.js');
require('./components/embeds.js');
require('./components/gravityforms.js');
require('./components/story-modal-popups.js');
require('./components/team-member-modal-popups.js');
